import { render, staticRenderFns } from "./MonitorsDashboard.vue?vue&type=template&id=7a89effb&"
import script from "./MonitorsDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitorsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MonitorsDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports